import { FieldType } from '@pmp/api';
import { CrudMode, FormItem, SelectsOptions } from '@ohpen/enso-ui';
import { GetFormSchema } from '@pmp/types';

export const getFormSchema = (selectsOptions: SelectsOptions): FormItem[] => [
  {
    title: 'pmp.products.labels.productCoreDefinition',
    valueType: 'group',
    fieldProps: {
      collapsible: 'true',
    },
    columns: [
      {
        title: 'pmp.products.labels.code',
        dataIndex: 'code',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.name',
        dataIndex: 'name',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.group',
        dataIndex: 'group',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.initialRateType',
        dataIndex: 'initialRateType',
        valueType: 'select',
        fieldProps: { disabled: true, options: selectsOptions[FieldType.INITIAL_RATE_TYPE] },
      },
      {
        title: 'pmp.products.labels.applicationTypes',
        dataIndex: 'applicationTypes',
        valueType: 'select',
        fieldProps: { disabled: true, mode: 'multiple' },
      },
      {
        title: 'pmp.products.labels.propertyPurpose',
        dataIndex: 'propertyPurpose',
        valueType: 'select',
        fieldProps: { disabled: true, options: selectsOptions[FieldType.PROPERTY_PURPOSE], mode: 'multiple' },
      },
      {
        title: 'pmp.products.labels.repaymentTypes',
        dataIndex: 'repaymentTypes',
        valueType: 'select',
        fieldProps: { disabled: true, mode: 'multiple' },
      },
      {
        title: 'pmp.products.labels.expat',
        dataIndex: 'expat',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.minDurationInMonths',
        dataIndex: 'minDurationInMonths',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.maxDurationInMonths',
        dataIndex: 'maxDurationInMonths',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.productTerm',
        dataIndex: 'productTerm',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.initialPeriodInMonths',
        dataIndex: 'initialPeriodInMonths',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.initialPeriodUntil',
        dataIndex: 'initialPeriodUntil',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.minTotalLoanAmount',
        dataIndex: 'minTotalLoanAmount',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.maxTotalLoanAmount',
        dataIndex: 'maxTotalLoanAmount',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.minLtv',
        dataIndex: 'minLtv',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.maxLtv',
        dataIndex: 'maxLtv',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.maxLti',
        dataIndex: 'maxLti',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.maxNumberOfApplicants',
        dataIndex: 'maxNumberOfApplicants',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.baseRate',
        dataIndex: 'baseRate',
        valueType: 'text',
        fieldProps: { disabled: true, options: selectsOptions[FieldType.BASE_RATES] },
      },
      {
        title: 'pmp.products.labels.ercProfile',
        dataIndex: 'ercProfile',
        valueType: 'select',
        fieldProps: { disabled: true, options: selectsOptions[FieldType.ERC_PROFILES] },
      },
      {
        title: 'pmp.products.labels.baseRate',
        dataIndex: 'baseRateAmount',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.surcharge',
        dataIndex: 'surcharge',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.margin',
        dataIndex: 'margin',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.rate',
        dataIndex: 'rate',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.stressRate',
        dataIndex: 'stressRate',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.followingProductCode',
        dataIndex: 'followingProductCode',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.cashback',
        dataIndex: 'cashback',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.feesAssisted',
        dataIndex: 'feesAssisted',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.freeValuation',
        dataIndex: 'freeValuation',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.feeProfile',
        dataIndex: 'feeProfile',
        valueType: 'select',
        fieldProps: { disabled: true, options: selectsOptions[FieldType.FEE_PROFILES] },
      },
      {
        title: 'pmp.products.labels.brands',
        dataIndex: 'brands',
        valueType: 'select',
        fieldProps: { disabled: true, mode: 'multiple', options: selectsOptions[FieldType.BRANDS] },
      },
      {
        title: 'pmp.products.labels.employmentType',
        dataIndex: 'employmentType',
        valueType: 'select',
        fieldProps: { disabled: true, options: selectsOptions[FieldType.EMPLOYMENT_TYPE] },
      },
      {
        title: 'pmp.products.labels.applicantTypes',
        dataIndex: 'applicantTypes',
        valueType: 'select',
        fieldProps: { disabled: true, mode: 'multiple', options: selectsOptions[FieldType.APPLICANT_TYPES] },
      },
      {
        title: 'pmp.products.labels.startDate',
        dataIndex: 'startDate',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.endDate',
        dataIndex: 'endDate',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.gracePeriodEndDate',
        dataIndex: 'gracePeriodEndDate',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.productCutoffDate',
        dataIndex: 'productCutoffDate',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.minTotalNetLoanAmount',
        dataIndex: 'minTotalNetLoanAmount',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.maxTotalNetLoanAmount',
        dataIndex: 'maxTotalNetLoanAmount',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.productFeePounds',
        dataIndex: 'productFeePounds',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.applicationFee',
        dataIndex: 'applicationFee',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.personOrCompany',
        dataIndex: 'personOrCompany',
        valueType: 'select',
        fieldProps: { disabled: true, options: selectsOptions[FieldType.PERSON_OR_COMPANY] },
      },
      {
        title: 'pmp.products.labels.occupancyTypes',
        dataIndex: 'occupancyTypes',
        valueType: 'text',
        fieldProps: { disabled: true, mode: 'multiple', options: selectsOptions[FieldType.OCCUPANCY_TYPE] },
      },
      {
        title: 'pmp.products.labels.portfolioLandlords',
        dataIndex: 'portfolioLandlords',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.schemes',
        dataIndex: 'schemes',
        valueType: 'select',
        fieldProps: { disabled: true, mode: 'multiple', options: selectsOptions[FieldType.SCHEME] },
      },
      {
        title: 'pmp.products.labels.green',
        dataIndex: 'green',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.energyPerformanceCertificateSaver',
        dataIndex: 'energyPerformanceCertificateSaver',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.replacesCode',
        dataIndex: 'replacesCode',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.replacedByCode',
        dataIndex: 'replacedByCode',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.productFeePercent',
        dataIndex: 'productFeePercent',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.productFeeBasedOn',
        dataIndex: 'productFeeBasedOn',
        valueType: 'select',
        fieldProps: { disabled: true, options: selectsOptions[FieldType.PROCURATION_FEE_BASIS] },
      },
      {
        title: 'pmp.products.labels.buildingTypes',
        dataIndex: 'buildingTypes',
        valueType: 'select',
        fieldProps: { disabled: true, mode: 'multiple', options: selectsOptions[FieldType.BUILDING_TYPE] },
      },
      {
        title: 'pmp.products.labels.regulatoryTypes',
        dataIndex: 'regulatoryTypes',
        valueType: 'select',
        fieldProps: { disabled: true, mode: 'multiple', options: selectsOptions[FieldType.REGULATORY_TYPE] },
      },
      {
        title: 'pmp.products.labels.projectTypes',
        dataIndex: 'projectTypes',
        valueType: 'select',
        fieldProps: { disabled: true, mode: 'multiple', options: selectsOptions[FieldType.PROJECT_TYPE] },
      },
      {
        title: 'pmp.products.labels.propertyTypes',
        dataIndex: 'propertyTypes',
        valueType: 'select',
        fieldProps: { disabled: true, mode: 'multiple', options: selectsOptions[FieldType.PROPERTY_TYPE] },
      },
      {
        title: 'pmp.products.labels.portable',
        dataIndex: 'portable',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.overpaymentsAllowed',
        dataIndex: 'overpaymentsAllowed',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.paymentsHoliday',
        dataIndex: 'paymentsHoliday',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.region',
        dataIndex: 'region',
        valueType: 'text',
        fieldProps: { disabled: true },
      },
      {
        title: 'pmp.products.labels.belongsToExclusivitySets',
        dataIndex: 'belongsToExclusivitySets',
        valueType: 'select',
        fieldProps: { disabled: true, mode: 'multiple', options: selectsOptions[FieldType.EXCLUSIVITY_SETS] },
      },
    ],
  },
];

export const getExportProductsFormSchema: GetFormSchema = (mode: CrudMode | null, selectsOptions: SelectsOptions): FormItem[] => {
  return [
    {
      title: 'global.labels.general',
      valueType: 'group',
      fieldProps: {
        collapsible: 'true',
      },
      columns: [
        {
          title: 'global.labels.id',
          dataIndex: 'id',
          valueType: 'text',
          fieldProps: {
            disabled: true,
          },
        },
        {
          title: 'global.labels.label',
          dataIndex: 'name',
          valueType: 'text',
          fieldProps: {
            disabled: true,
          },
        },
        {
          title: 'global.labels.description',
          dataIndex: 'description',
          valueType: 'textarea',
          fieldProps: {
            disabled: true,
          },
        },
        {
          title: 'global.labels.view',
          dataIndex: 'view',
          tooltip: 'global.labels.viewTooltip',
          valueType: 'select',
          fieldProps: {
            options: selectsOptions[FieldType.YES_NO], // Add new FieldType with products views
            disabled: true,
          },
        },
      ],
    },
    {
      title: 'global.labels.replaceColumnHeaders',
      valueType: 'group',
      fieldProps: {
        collapsible: 'true',
      },
      columns: [
        {
          title: 'pmp.products.labels.code',
          dataIndex: ['template', 'code'],
          valueType: 'text',
          fieldProps: {
            disabled: true,
          },
        },
        {
          title: 'pmp.products.labels.name',
          dataIndex: ['template', 'name'],
          valueType: 'text',
          fieldProps: {
            disabled: true,
          },
        },
        {
          title: 'pmp.products.labels.productGroup',
          dataIndex: ['template', 'productGroup'],
          valueType: 'text',
          fieldProps: {
            disabled: true,
          },
        },
        {
          title: 'pmp.products.labels.initialRateType',
          dataIndex: ['template', 'initialRateType'],
          valueType: 'text',
          fieldProps: {
            disabled: true,
          },
        },
        {
          title: 'pmp.products.labels.baseRate',
          dataIndex: ['template', 'baseRateId'],
          valueType: 'text',
          fieldProps: {
            disabled: true,
          },
        },
        {
          title: 'pmp.products.labels.surcharge',
          dataIndex: ['template', 'surcharge'],
          valueType: 'text',
          fieldProps: {
            disabled: true,
          },
        },
        {
          title: 'pmp.products.labels.stressRate',
          dataIndex: ['template', 'stressRate'],
          valueType: 'text',
          fieldProps: {
            disabled: true,
          },
        },
        {
          title: 'pmp.products.labels.margin',
          dataIndex: ['template', 'margin'],
          valueType: 'text',
          fieldProps: {
            disabled: true,
          },
        },
        {
          title: 'pmp.products.labels.rate',
          dataIndex: ['template', 'rate'],
          valueType: 'text',
          fieldProps: {
            disabled: true,
          },
        },
        {
          title: 'pmp.products.labels.startDate',
          dataIndex: ['template', 'startDate'],
          valueType: 'text',
          fieldProps: {
            disabled: true,
          },
        },
        {
          title: 'pmp.products.labels.endDate',
          dataIndex: ['template', 'endDate'],
          valueType: 'text',
          fieldProps: {
            disabled: true,
          },
        },
        {
          title: 'pmp.products.labels.followingProductCode',
          dataIndex: ['template', 'followingProductCode'],
          valueType: 'text',
          fieldProps: {
            disabled: true,
          },
        },
        {
          title: 'pmp.products.labels.feesAssisted',
          dataIndex: ['template', 'feesAssisted'],
          valueType: 'text',
          fieldProps: {
            disabled: true,
          },
        },
        {
          title: 'pmp.products.labels.feeProfile',
          dataIndex: ['template', 'feeProfileId'],
          valueType: 'text',
          fieldProps: {
            disabled: true,
          },
        },
        {
          title: 'pmp.products.labels.ercProfile',
          dataIndex: ['template', 'ercProfileId'],
          valueType: 'text',
          fieldProps: {
            disabled: true,
          },
        },
        {
          title: 'pmp.products.labels.minDurationInMonths',
          dataIndex: ['template', 'minDurationInMonths'],
          valueType: 'text',
          fieldProps: {
            disabled: true,
          },
        },
        {
          title: 'pmp.products.labels.maxDurationInMonths',
          dataIndex: ['template', 'maxDurationInMonths'],
          valueType: 'text',
          fieldProps: {
            disabled: true,
          },
        },
        {
          title: 'pmp.products.labels.initialPeriodInMonths',
          dataIndex: ['template', 'initialPeriodInMonths'],
          valueType: 'text',
          fieldProps: {
            disabled: true,
          },
        },
        {
          title: 'pmp.products.labels.belongsToExclusivitySets',
          dataIndex: ['template', 'belongsToExclusivitySetIds'],
          valueType: 'text',
          fieldProps: {
            disabled: true,
            mode: 'multiple',
          },
        },
      ],
    },
  ];
};
